/**
 * @param actions object contains actions list; could be edit, delete, and preview actions.
 *
 * @returns Array of authorized action columns for EuiTable
 */
import { useLocation } from "react-router-dom";

const isProjectApproved = (item) => item.status === "Approved";

const isAutomationRunning = (item) => item.automationStatus === "running";

const isAutomationPaused = (item) => item.automationStatus === "paused";

export default (actions) => {
    const {
        editAction,
        deleteAction,
        previewAction,
        verificationAction,
        runAutomateAction,
        pauseAutomateAction,
    } = actions;
    const columnActions = [];
    const location = useLocation();

    previewAction &&
        location.pathname !== "/database/trucks" &&
        !/^\/database\/drivers\/(\d+)$/.test(location.pathname) &&
        columnActions.push({
            name: "Preview",
            description: "Preview",
            icon: "document",
            type: "icon",
            onClick: previewAction,
        });

    editAction &&
        columnActions.push({
            name: "Edit",
            description: "Edit",
            icon: "documentEdit",
            type: "icon",
            color: "primary",
            onClick: editAction,
        });

    deleteAction &&
        columnActions.push({
            name: "Delete",
            description: "Delete",
            icon: "trash",
            type: "icon",
            color: "danger",
            onClick: deleteAction,
        });
    verificationAction &&
        columnActions.push({
            name: "Verification",
            description: "Verification",
            icon: "checkInCircleFilled",
            type: "icon",
            color: "danger",
            onClick: verificationAction,
        });

    runAutomateAction &&
        columnActions.push({
            name: "Run Automation",
            description: "Run Automation",
            icon: "check",
            type: "icon",
            color: "primary",
            onClick: runAutomateAction,
            available: (item) => isProjectApproved(item) && isAutomationPaused(item),
        });

    pauseAutomateAction &&
        columnActions.push({
            name: "Pause Automation",
            description: "Pause Automation",
            icon: "pause",
            type: "icon",
            color: "primary",
            onClick: pauseAutomateAction,
            available: (item) => isProjectApproved(item) && isAutomationRunning(item),
        });

    return columnActions;
};
